const tagsView = {
    state: {

    },
    mutations: {

    },
    actions: {

    }
}

export default tagsView


// WEBPACK FOOTER //
// ./src/store/modules/tagsView.js